import LevelsTable from './tables/LevelsTable';
import { BfiCustomStore, SectionHeader, Accordion } from '../common/SharedComponents';

const ExperienceLevelsLanding = () => {
    const gridStore = new BfiCustomStore();

    return (
        <>
            <SectionHeader title='Experience Levels' />
            <div
                className='main-content no-search'
                style={{ padding: 0, backgroundColor: '#f4f4f4' }}
            >
                <div
                    className='scrollable-content-without-search'
                    style={{ padding: '1rem' }}
                >
                    <div
                        className='accordion'
                        data-accordion=''
                        data-allow-all-closed='true'
                        data-multi-expand='true'
                    >
                        <Accordion
                            title='Levels'
                            isExpanded={true}
                            id={`ExperienceLevels`}
                        >
                            <div className='card'>
                                <div className='card-section'>
                                    <LevelsTable gridStore={gridStore} />
                                </div>
                            </div>
                        </Accordion>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ExperienceLevelsLanding;
